<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="p-3">
    <div class="vx-row mb-3">
      <div class="vx-col w-full md:w-1/2 lg:w-2/5">
        <div class="vx-row">
          <div class="vx-col mb-3 w-full">
            <vx-card>
              <vs-list>
                <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`ขั้นตอนการปฏิบัติงาน`"></vs-list-header>
                <div>
                  <vs-list-item title="1. พิมพ์สัญญากู้ยืมเงิน และหนังสือให้ความยินยอม หรือหากมีการรับมอบเอกสารจากเจ้าหน้าที่แล้วให้ข้ามขั้นตอนนี้ไป"></vs-list-item>
                  <vs-list-item title="2. ตรวจสอบเอกสารสัญญากู้ยืมเงิน และหนังสือให้ความยินยอม ชื่อ-นามสกุล ตรงกับข้อมูลผู้กู้หรือไม่ หากข้อมูลไม่ตรงกันให้ดำเนินการติดต่อเจ้าหน้าที่"></vs-list-item>
                  <vs-list-item title="3. นำเอกสารดังกล่าวให้ผู้กู้เซ็นต์ ตรวจสอบความถูกต้องของเอกสาร"></vs-list-item>
                  <vs-list-item title="4. ดำเนินการถ่ายรูปหรือวิดีโอผู้กู้ โดยให้ถ่ายผู้กู้คู่กับเอกสาร"></vs-list-item>
                  <vs-list-item title="5. อัพโหลดรูปถ่ายหรือวิดีโอ และตรวจสอบความถูกต้อง "></vs-list-item><br>
                  <vs-alert color="danger" title="คำแนะนำ" icon="icon-info" icon-pack="feather">
                    <p>กรุณาตรวจสอบรูปถ่ายหรือวิดีโอ หลังจากอัพโหลดเสร็จเรียบร้อย โดยหากไม่สามารถอัพโหลดหรือเกิดปัญหาในการอัพโหลดให้ส่งรูปถ่ายหรือวิดีโอดังกล่าวมาที่ line @world.loan</p>
                  </vs-alert>
                </div>
              </vs-list>
            </vx-card>
          </div>
          <div class="vx-col mb-3 w-full" v-if="borrower">
            <vx-card>
              <vs-list>
                <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`เอกสารสำหรับผู้กู้`"></vs-list-header>
                <div>
                  <vs-list-item :title="`สัญญากู้ยืมเงิน ${borrower.fullName}`">
                    <vs-button type="line" line-origin="left" color="success" @click="openUrl(contractWithSmartAppPath)">พิมพ์</vs-button>
                  </vs-list-item>
                  <vs-list-item :title="`หนังสือให้ความยินยอม ${borrower.fullName}`">
                    <vs-button type="line" line-origin="left" color="success" @click="openUrl(borrowerPdpaWithSmartAppPath)">พิมพ์</vs-button>
                  </vs-list-item>
                </div>
              </vs-list>
            </vx-card>
          </div>
          <div class="vx-col mb-3 w-full">
            <vx-card>
              <vs-list>
                <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`อัพโหลดรูปถ่ายยืนยัน`"></vs-list-header>
                <vs-list-item title="รูปถ่ายยืนยัน" v-if="showFileImageApproved">
                  <vs-button type="line" line-origin="left" color="success" @click="openFileUrl(borrower.fileImageApproved)">เรียกดู</vs-button>
                </vs-list-item>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <input class="mt-5 mb-5" type="file" @change="onFileChange" ref="inputFile"/>
                  </div>
                  <div class="vx-col w-1/2 text-right">
                    <vs-button class="btn-icon mt-5 mb-5 mr-3" size="small" color="warning" :disabled="!selectedFile" @click="onUploadFile" >อัพโหลด</vs-button>
                  </div>
                  <vs-alert v-if="selectedFileValid" color="danger" title="คำแนะนำ" icon="icon-info" icon-pack="feather">
                    <p>กรุณาอัพโหลดเป็นไฟล์รูปถ่ายเท่านั้น</p>
                  </vs-alert>
                </div>
              </vs-list>
            </vx-card>
          </div>
          <div class="vx-col mb-3 w-full">
            <vx-card>
              <vs-list>
                <vs-list-header icon-pack="feather" icon="icon-paperclip" :title="`อัพโหลดวิดีโอยืนยัน`"></vs-list-header>
                <vs-list-item title="วิดีโอยืนยัน" v-if="showFileVideoApproved">
                  <vs-button type="line" line-origin="left" color="success" @click="openFileUrl(borrower.fileVideoApproved)">เรียกดู</vs-button>
                </vs-list-item>
                <div class="vx-row">
                  <div class="vx-col w-1/2">
                    <input class="mt-5 mb-5" type="file" @change="onFileVideoChange" ref="inputFileVideo"/>
                  </div>
                  <div class="vx-col w-1/2 text-right">
                    <vs-button class="btn-icon mt-5 mb-5 mr-3" size="small" color="warning" :disabled="!selectedFileVideo" @click="onUploadFileVideo" >อัพโหลด</vs-button>
                  </div>
                  <vs-alert v-if="selectedFileVideoValid" color="danger" title="คำแนะนำ" icon="icon-info" icon-pack="feather">
                    <p>กรุณาอัพโหลดเป็นไฟล์วิดีโอเท่านั้น</p>
                  </vs-alert>
                </div>
              </vs-list>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="vx-col w-full md:w-1/2 lg:w-3/5">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full vx-coll-fixed-height">
              <template v-if="contract">
                <vs-divider position="center">ข้อมูลสัญญา</vs-divider>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เลขที่สัญญา</h6>
                    <p>{{ contract.contractNo }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ชื่อสัญญา</h6>
                    <p >{{ contract.contractName}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันที่สัญญา</h6>
                    <p >{{ contract.contractDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ยอดเงินกู้</h6>
                    <p >{{ contract.contractAmount | numberFormat }}</p>
                  </div>
                </div>
              </template>
              <template v-if="borrower">
                <vs-divider position="center">ข้อมูลผู้กู้</vs-divider>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เลขที่บัตรประชาชน</h6>
                    <p>{{ borrower.idCardNumber }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ออกให้เมื่อวันที่</h6>
                    <p >{{ borrower.issueDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันที่หมดอายุ</h6>
                    <p >{{ borrower.expDate | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>วันเกิด</h6>
                    <p >{{ borrower.birthDay | convYYYYMMDDToDDMMYYYY}}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เพศ</h6>
                    <p >{{ borrower.genderName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>ชื่อ-สกุล</h6>
                    <p >{{ borrower.fullName }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>เบอร์โทร</h6>
                    <p >{{ borrower.mobile }}</p>
                  </div>
                  <div class="vx-col mb-5 w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
                    <h6>อีเมล</h6>
                    <p >{{ borrower.email }}</p>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col mb-5 w-full">
                    <h6>ที่อยู่</h6>
                    <p >{{ borrower.fullAddress }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createNamespacedHelpers } from 'vuex'
import vSelect from 'vue-select'
const moment = require('moment');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css';
import {getUploadsUrl} from "@/utils/upload";

const {mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      form:{
        description: ""
      },
      selectedFile: null,
      selectedFileValid: false,
      selectedFileVideo: null,
      selectedFileVideoValid: false,
      reportServer: process.env.VUE_APP_REPORT_SERVER
    };
  },
  async mounted () {
    const vm = this
    await vm.getContractWithOutAuth({form: {id: vm.$route.params.id, token: vm.$route.params.token}});
  },
  computed: {
    ...mapAccountingState(['status', 'contract']),
    borrower (){
      if (this.contract){
        return this.contract.borrower
      }else{
        return null
      }
    },
    smartAppStatus (){
      return this.contract.smartAppStatus
    },
    contractStatus (){
      return this.contract.contractStatus
    },
    contractWithSmartAppPath(){
      return `${this.reportServer}/pdf/contractWithSmartApp?id=${this.contract.id}`;
    },
    borrowerPdpaWithSmartAppPath(){
      return `${this.reportServer}/pdf/borrowerPdpaWithSmartApp?id=${this.contract.id}`;
    },
    showFileImageApproved(){
      try {
        let result = this.borrower.fileImageApproved.fileName !== null
        return result
      }catch (e) {
        return false;
      }
    },
    showFileVideoApproved(){
      try {
        let result = this.borrower.fileVideoApproved.fileName !== null
        return result
      }catch (e) {
        return false;
      }
    }
  },
  methods: {
    ...mapAccountingActions(['getContractWithOutAuth', 'updateFileWithOutAuth', 'uploadFile']),
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    },
    openUrl(url){
      window.open(url, '_blank');
    },
    openFileUrl(file){
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0]; // accessing file
      const { type } = selectedFile;
      if ( type.includes("image/") ){
        this.selectedFile = selectedFile;
        this.selectedFileValid = false;
      }else{
        this.selectedFile = null;
        this.$refs.inputFile.value= null
        this.selectedFileValid = true;
      }
    },
    async onUploadFile() {
      const vm = this
      const formData = new FormData()
      formData.append("file", this.selectedFile);  // appending file
      const result = await vm.uploadFile ({
        id: vm.$route.params.id,
        form: {
          formData: formData
        },
        vm
      });
      await vm.updateFileWithOutAuth({
        id: vm.borrower.fileImageApproved.id,
        token: vm.$route.params.token,
        form: {
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      await vm.getContractWithOutAuth({form: {id: vm.$route.params.id, token: vm.$route.params.token}});
      vm.form.description = ""
      vm.selectedFile = null
      vm.selectedFileValid = false
      vm.$refs.inputFile.value= null
    },
    onFileVideoChange(e) {
      const selectedFileVideo = e.target.files[0]; // accessing file
      const { type } = selectedFileVideo;
      if ( type.includes("video/") ){
        this.selectedFileVideo = selectedFileVideo;
        this.selectedFileVideoValid = false;
      }else{
        this.selectedFileVideo = null;
        this.$refs.inputFileVideo.value= null
        this.selectedFileVideoValid = true;
      }
    },
    async onUploadFileVideo() {
      const vm = this
      const formData = new FormData()
      formData.append("file", this.selectedFileVideo);  // appending file
      const result = await vm.uploadFile ({
        id: vm.$route.params.id,
        form: {
          formData: formData
        },
        vm
      });
      await vm.updateFileWithOutAuth({
        id: vm.borrower.fileVideoApproved.id,
        token: vm.$route.params.token,
        form: {
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      await vm.getContractWithOutAuth({form: {id: vm.$route.params.id, token: vm.$route.params.token}});
      vm.form.description = ""
      vm.selectedFileVideo = null
      vm.selectedFileVideoValid = false
      vm.$refs.inputFileVideo.value= null
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>


<style scoped>
.vx-coll-fit-height{
  display:block;
  width:100%;
  height:100%;
  overflow: auto;
}
.vx-coll-fixed-height{
  display:block;
  width:100%;
  /*min-height: 500px;*/
  height:100%;
  overflow: auto;
}
.custom-hr{
  margin-top: 10px; margin-bottom: 20px;border: 0;
  border-top: 1px solid #eee;
}
</style>
